export default "__VITE_ASSET__BbZLMwHP__"